import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, AlertCircle } from 'lucide-react';
import { adminApi, formatApiError } from '../utils/adminApi';
import SEO from '../components/SEO';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If already authenticated, send to dashboard
    adminApi.me().then(() => navigate('/admin', { replace: true })).catch(() => {});
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await adminApi.login(email.trim().toLowerCase(), password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(formatApiError(err, 'Login failed.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-shell" data-testid="admin-login-page">
      <SEO title="Admin Login" path="/admin/login" noIndex />
      <div className="admin-login-card">
        <div className="admin-login-header">
          <p className="navigation-text" style={{ color: 'var(--accent-gold)' }}>Atelier</p>
          <h1 className="hero-large" style={{ marginTop: 8 }}>Silk &amp; Sentiment</h1>
          <p className="body-large" style={{ marginTop: 10 }}>Admin access</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <label className="admin-field">
            <span className="admin-field-label"><Mail size={14} /> Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="info@silkandsentiment.com"
              data-testid="admin-login-email"
              autoComplete="email"
            />
          </label>
          <label className="admin-field">
            <span className="admin-field-label"><Lock size={14} /> Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="admin-login-password"
              autoComplete="current-password"
            />
          </label>

          {error && (
            <div className="admin-error" data-testid="admin-login-error">
              <AlertCircle size={14} /> {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="admin-login-submit"
            style={{ width: '100%', marginTop: 8 }}
          >
            {loading ? 'Signing in…' : 'Enter Atelier'}
          </button>
        </form>

        <p className="body-small" style={{ marginTop: 28, textAlign: 'center', color: 'var(--text-light)' }}>
          Authorised personnel only
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
